import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~shared/api";

export const useGetSeasonPersonsStatisticReportUrl = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();

  return useQuery({
    queryKey: ["seasonPersonsStatisticReport", sport, organizationId, seasonId],
    queryFn: async () => {
      return await fetchData({
        url: `${sport}/o/${organizationId}/reports/persons/statistic/in/season/${seasonId}`,
      });
    },
    enabled: false,
  });
};
